<template>
    <div class="global-loading-overlay" v-if="show">
        <div class="loading"></div>
    </div>
</template>
<script>
    export default {
        props: ['show'],
    }
</script>